<template>
  <div>
    <Divider orientation="left">个人信息变更确认</Divider>
    <Form :ref="'form' + current" :model="form" :rules="rules" :label-width="165">
      <Row :gutter="16">
        <Col span="24">
        <FormItem label="姓名变更">
          <Checkbox disabled v-model.trim="form.isNameChanged"></Checkbox>
        </FormItem>
        </Col>
        <Col span="12">
        <FormItem label="变更前姓名">
          <Input v-model.trim="form.oldName" disabled :maxlength="40" ></Input>
        </FormItem>
        </Col>
        <Col span="12">
        <FormItem label="变更后姓名"  >
          <Input v-model.trim="form.newName" disabled :maxlength="40" ></Input>
        </FormItem>
        </Col>
        <Col span="24">
        <FormItem class="noticeTop" label="证明材料" >
          <!-- <Upload style="flex: 1" :show-upload-list="false" :default-file-list="form.nameChangedFileGuidListPreview" :action="$baseURL + '/common/file/uploadfile'" :on-preview="handlePreview" :data="uploadData" :on-remove="
                (file, fileList) =>
                  handleRemove(file, fileList, 'nameChangedFileGuidList',true)
              " :on-success="
                (response, file, fileList) =>
                  handleSuccess(
                    response,
                    file,
                    fileList,
                    'nameChangedFileGuidList',true
                  )
              " :on-format-error="handleFormatError">
            <Button icon="ios-cloud-upload-outline">上传文件</Button>
          </Upload> -->
          <div class="_link" v-for="item in form.nameChangedFileGuidListPreview" @click="handlePreview(item)" :key="item.guid">
            <Icon :type="item.name | fileType" />
            {{item.name}}
          </div>
          <span class='_noLink' v-if="form.nameChangedFileGuidListPreview.length<1">无</span>

        </FormItem>
        <FormItem class="notice">
          <div>现用名和曾用名的户口本单页及首页/户籍证明</div>
        </FormItem>
        </Col>
        <Col span="24">
        <FormItem prop="isIDCardNoChanged" label="身份证号码变更">
          <Checkbox disabled v-model.trim="form.isIDCardNoChanged"></Checkbox>
        </FormItem>
        </Col>
        <Col span="12">
        <FormItem label="变更前身份证号码" :required="form.isIDCardNoChanged" >
          <Input v-model.trim="form.oldIDCardNo" disabled :maxlength="40" ></Input>
        </FormItem>
        </Col>
        <Col span="12">
        <FormItem label="变更后身份证号码" :required="form.isIDCardNoChanged" >
          <Input v-model.trim="form.newIDCardNo" disabled :maxlength="40" ></Input>
        </FormItem>
        </Col>
        <Col span="24">
        <FormItem class="noticeTop" label="证明材料" :required="form.isIDCardNoChanged" >
          <!-- <Upload :show-upload-list="false" :default-file-list="form.idCardNoChangedFileGuidListPreview" style="flex: 1" :action="$baseURL + '/common/file/uploadfile'" :on-preview="handlePreview" :data="uploadData" :on-remove="
                (file, fileList) =>
                  handleRemove(file, fileList, 'idCardNoChangedFileGuidList',true)
              " :on-success="
                (response, file, fileList) =>
                  handleSuccess(
                    response,
                    file,
                    fileList,
                    'idCardNoChangedFileGuidList',
                    true
                  )
              " :on-format-error="handleFormatError">
            <Button icon="ios-cloud-upload-outline">上传文件</Button>
          </Upload> -->
          <div class="_link" v-for="item in form.idCardNoChangedFileGuidListPreview" @click="handlePreview(item)" :key="item.guid">
            <Icon :type="item.name | fileType" />
            {{item.name}}
          </div>
          <span class='_noLink' v-if="form.idCardNoChangedFileGuidListPreview.length<1">无</span>
        </FormItem>
        <FormItem class="notice">
          <div>公民身份证号码变更证明等公安部门出具的证明</div>
        </FormItem>
        </Col>
      </Row>
    </Form>
  </div>
</template>
<script>
export default {
  props: { form: { type: Object }, current: { type: Number } },
  data() {
    return {
      format: ['jpg', 'png', 'jpeg'],
      accept: 'image/*',
      //   form: { id: 'ywlsh_12356789', kh: '新开户', sfzzm: [] },
      uploadData: {},

      appInfoDataType: this.$store.state.appInfoDataType,
      current_index: this.current,
      rules: {
        // oldName: [
        //   {
        //     required: this.form.isNameChanged,
        //     message: "请输入",
        //     trigger: "change",
        //   },
        // ],
        // newName: [
        //   {
        //     required: this.form.isNameChanged,
        //     message: "请输入",
        //     trigger: "change",
        //   },
        // ],
        // nameChangedFileGuidList: [
        //   {
        //     required: this.form.isNameChanged,
        //     message: "请上传",
        //     trigger: "change",
        //   },
        // ],
        // oldIDCardNo: [
        //   {
        //     required: this.form.isIDCardNoChanged,
        //     message: "请输入",
        //     trigger: "change",
        //   },
        // ],
        // newIDCardNo: [
        //   {
        //     required: this.form.isIDCardNoChanged,
        //     message: "请输入",
        //     trigger: "change",
        //   },
        // ],
        // idCardNoChangedFileGuidList: [
        //   {
        //     required: this.form.isIDCardNoChanged,
        //     message: "请上传",
        //     trigger: "change",
        //   },
        // ],
      },
      clList: ['rl', 'dw', 'yy', 'sh', 'rl'],
      selectList: [
        { name: '是', value: 1 },
        { name: '否', value: 0 },
      ],
    }
  },
  methods: {
    //下一步
    next(name, val) {
      let _this = this
      //上一步
      if (val < this.current) {
        this.$emit('next', val)
        return
      }
    },
    //提交
    submit(name) {
      let _this = this
      this.$refs[name].validate(async (valid) => {
        if (!valid) {
          this.$Message.error('请将信息填写完整')
          return
        }

        await this.$emit(
          'submit',
          '/api/services/app/JZZJFApi/SaveAppPersonalInfoChangeInfo',
          1,
          '提交成功'
        )
      })
      //  await this.$emit('submit', '/api/services/app/JZZJFApi/SubmitApplication', 1,'提交成功')
    },
    //移除文件
    async handleRemove(file, fileList, property, isArray) {
      this.$emit('handleRemove', file, fileList, property, isArray)
    },
    //文件上传成功
    handleSuccess(response, file, fileList, property, isArray) {
      this.$emit('handleSuccess', response, file, fileList, property)
    },
    //文件格式错误
    handleFormatError(file) {
      this.$emit('handleFormatError', file)
    },
    //文件预览
    handlePreview(file) {
      this.$emit('handlePreview', file)
    },
  },
}
</script>